export default __webpack_public_path__ + "static/media/9.ea402645.png";